<div class="container" xmlns="http://www.w3.org/1999/html">
  <app-title-header></app-title-header>

  <section class="card">
    <p i18n="@@CONTACT_FORM.TELL_US_MORE">Tell us a bit more about yourself</p>
    <form
      class="contact-form"
      data-testid="contact-form"
      (ngSubmit)="onSubmit()"
      [formGroup]="form"
      novalidate
    >
      <div class="form-row">
        <mat-form-field class="half-fill" appearance="outline">
          <mat-label i18n="@@CONTACT_FORM.FIRST_NAME">First Name</mat-label>
          <input
            matInput
            id="firstName"
            [formControl]="firstNameControl"
          />
          @if (form.get('firstName').hasError('required') ||
          form.get('firstName').hasError('pattern')) {
          <mat-error> This field is required </mat-error>
          }
        </mat-form-field>

        <mat-form-field class="half-fill" appearance="outline">
          <mat-label i18n="@@CONTACT_FORM.LAST_NAME">Last Name</mat-label>
          <input matInput id="lastName" [formControl]="lastNameControl" />
          @if (form.get('lastName').hasError('required') ||
          form.get('lastName').hasError('pattern')) {
          <mat-error> This field is required </mat-error>
          }
        </mat-form-field>
      </div>

      <mat-form-field
        [ngClass]="{ 'email-field': !showInviteeEmails }"
        class="fill"
        appearance="outline"
      >
        <mat-label i18n="@@CONTACT_FORM.EMAIL">Email</mat-label>
        <input
          matInput
          id="email"
          type="email"
          [formControl]="emailControl"
        />
        @if (emailFieldErrors?.invalidEmail) {
        <mat-error>Email is invalid</mat-error>
        } @if (emailFieldErrors?.required) {
        <mat-error>This field is required</mat-error>
        }
      </mat-form-field>

      @if (isPrimaryEmailDuplicate && isEmailFieldTouched) {
      <div class="email-duplicate-error">
        This email is already present in the additional guest list
      </div>
      } @if (!showInviteeEmails && isEmailRequired) {
      <div
        (click)="displayInviteeEmailField()"
        class="invite-more-guests-button"
      >
        + Invite more guests
      </div>
      } @if (showInviteeEmails) {
      <mat-form-field class="fill invitee-field" appearance="outline">
        <mat-label i18n="@@CONTACT_FORM.INVITEE_EMAIL"
          >Additional guest email(s)</mat-label
        >
        <mat-chip-grid
          data-testid="invitee-email-chips"
          #chipGrid
          aria-label="Additional email list"
        >
          @for (email of inviteeEmails; track email) {
          <mat-chip-row (removed)="removeInviteeEmail(email)">
            {{ email }}
            <button matChipRemove aria-label="Remove email">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
          }
        </mat-chip-grid>
        <input
          #additionalEmails
          matChipInput
          name="invitee-emails"
          type="email"
          [matChipInputFor]="chipGrid"
          [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
          (matChipInputTokenEnd)="addInviteeEmail($event.value)"
          (input)="onInviteeInput($event)"
          (blur)="addInviteeEmail(additionalEmails.value)"
          (paste)="addInviteeEmailsFromPaste($event)"
        />
      </mat-form-field>
      @if (inviteeInputInvalid && displayDuplicateEmail) {
      <div class="invitee-email-error" data-testid="invitee-emails-error">
        "{{ displayDuplicateEmail }}" is not a valid email
      </div>
      } }

      <app-phone-input
        class="form-element"
        #galaxyPhoneInput
        id="phoneNumber"
        [formControl]="phoneNumberControl"
        label="Phone Number"
        i18n-label="@@CONTACT_FORM.PHONE_NUMBER"
        [required]="isPhoneNumberRequired"
      ></app-phone-input>

      @if (showSmsConsent) {
      <div class="sms-consent-notice" role="note">
        <mat-icon class="sms-consent-notice-icon">info</mat-icon>
        <span i18n="@@BOOK.SMS_CONSENT_DISCLOSURE">
          {{ 'BOOK.SMS_CONSENT_DISCLOSURE' | translate }}
        </span>
      </div>
      }

      @if (isClientSiteMeeting) {
      <mat-form-field class="fill location" appearance="outline">
        <mat-label i18n="@@CONTACT_FORM.Location">Location</mat-label>
        <input matInput id="location" [formControl]="locationControl" />
        @if (form.get('location').hasError('required') ||
        form.get('location').hasError('pattern')) {
        <mat-error> This field is required </mat-error>
        }
      </mat-form-field>
      } @if (isClientSiteMeeting && locationGuideLines.trim().length > 0) {
      <span class="location-guidelines-container">
        <div class="location-guidelines">
          {{ locationGuideLines.trim() }}
        </div>
      </span>
      }

      <app-dynamic-form
        class="form-element"
        [fields]="customFormFields"
      ></app-dynamic-form>

      <mat-form-field class="fill comments">
        <mat-label i18n="@@CONTACT_FORM.COMMENTS">Comments</mat-label>
        <textarea
          matInput
          name="comments"
          formControlName="comment"
          cdkTextareaAutosize
          cdkAutosizeMinRows="4"
        ></textarea>
      </mat-form-field>

      @if (!submitted) {
      <p>
        @if (timeSlot$ | async; as timeSlot) {
        <button
          class="fill contact-form-submit"
          mat-flat-button
          color="primary"
          data-testid="contact-form-submit-btn"
          i18n="@@CONTACT_FORM.SCHEDULE_MEETING_FOR_DATE_TIME"
          type="submit"
          [disabled]="
            form.invalid ||
            submitting ||
            isPrimaryEmailDuplicate ||
            isPhoneInvalid ||
            inviteeInputInvalid
          "
        >
          Schedule meeting for {{ timeSlot.start | date : 'EEEE, LLLL d' }} at
          {{ timeSlot.start | date : 'h:mm a' : (timezoneOffset$ | async) }}
          {{ timezoneDisplay$ | async }}
        </button>
        }
      </p>
      <p>
        <a
          data-testid="contact-form-cancel-btn"
          class="fill contact-form-cancel-button"
          mat-button
          [routerLink]="['../']"
          [queryParamsHandling]="'preserve'"
          i18n="@@CONTACT_FORM.CHANGE_MEETING_TIME"
        >
          On second thought, I'd like to change the time
        </a>
      </p>
      @if (showSmsConsent) {
      <p class="terms-links">
        <a
          href="https://businessapp.io/privacy-policy/"
          target="_blank"
          rel="noopener noreferrer"
          i18n="@@CONTACT_FORM.PRIVACY_POLICY"
          >Privacy Policy</a
        >
        <span class="terms-separator">&bull;</span>
        <a
          href="https://businessapp.io/terms-of-service/"
          target="_blank"
          rel="noopener noreferrer"
          i18n="@@CONTACT_FORM.TERMS_OF_SERVICE"
          >Terms of Service</a
        >
      </p>
      } }
    </form>
  </section>
</div>
